import React from 'react';
import PropTypes from 'prop-types';
import Button from '@Components/Button';

function Footer({ onActivationConfirm }) {
  return (
    <div className="els-btn-group-right remote-access-dialog__footer">
      <Button
        buttonConfig={{
          type: 'primary',
          size: 'sm',
          label: 'Got it',
          e2eName: 'remote-access-email-continue',
        }}
        onClick={onActivationConfirm}
      />
    </div>
  );
}

Footer.defaultProps = {
  onActivationConfirm: () => null,
};

Footer.propTypes = {
  onActivationConfirm: PropTypes.func,
};

export default Footer;
